import { Link, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { LogOut, Loader } from 'lucide-react'
import Logo from '../common/Logo'
import { vendorService } from '../../services/vendorService'
import toast from 'react-hot-toast'

const AuthHeader = ({ rightAction = null }) => {
  const navigate = useNavigate()
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoggingOut, setIsLoggingOut] = useState(false)

  useEffect(() => {
    // Check if user is authenticated
    const checkAuth = () => {
      const token = sessionStorage.getItem('authToken')
      setIsAuthenticated(!!token)
    }
    
    checkAuth()
    // Check periodically for auth changes
    const interval = setInterval(checkAuth, 1000)
    return () => clearInterval(interval)
  }, [])

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true)
      await vendorService.logout()
      toast.success('Logged out successfully')
      navigate('/auth/login', { replace: true })
    } catch (error) {
      console.error('Logout error:', error)
      toast.error('Error during logout')
      // Still navigate to login even if logout API fails
      navigate('/auth/login', { replace: true })
    } finally {
      setIsLoggingOut(false)
    }
  }

  return (
    <header className="glass-effect border-b border-secondary-200 dark:border-secondary-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <Logo />
            <span className="text-2xl font-display font-bold bg-gradient-to-r from-primary-700 to-accent-700 dark:from-primary-400 dark:to-accent-400 bg-clip-text text-transparent">
              AJA Bench
            </span>
          </Link>
          
          {rightAction || (isAuthenticated && (
            <button
              onClick={handleLogout}
              disabled={isLoggingOut}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-secondary-700 dark:text-secondary-300 hover:text-primary-600 dark:hover:text-primary-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              title="Logout"
            >
              {isLoggingOut ? (
                <>
                  <Loader className="w-4 h-4 animate-spin" />
                  <span>Logging out...</span>
                </>
              ) : (
                <>
                  <LogOut className="w-4 h-4" />
                  <span>Logout</span>
                </>
              )}
            </button>
          ))}
        </div>
      </div>
    </header>
  )
}

export default AuthHeader

